import { RealTimeDataStore } from "@app/services/store/real-time-data-store";
import { WebStompEntitySubscriber } from "@app/services/webstomp/web-stomp-entity-subscriber.service";
import { Injectable, inject } from "@angular/core";
import { GroupRestService } from "@app/services/hal/group-rest.service";
import { WorkGroup } from "@app/models/rest/work-group";
import { HateoasResourceService } from "@lagoshny/ngx-hateoas-client";

@Injectable({ providedIn: "root" })
export class GroupStore extends RealTimeDataStore<WorkGroup> {
  constructor() {
    const groupRestService = inject(GroupRestService);
    const webStompSubscriber = inject(WebStompEntitySubscriber);
    const hateoasResourceService = inject(HateoasResourceService);

    super(groupRestService, webStompSubscriber, hateoasResourceService);
    super.subscribeToMessaging("WorkGroup");
  }
}
